// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".overlay[data-v-7e2b81b6]{background:linear-gradient(246.38deg,transparent 35.83%,rgba(0,0,0,.4) 100.24%)}.title[data-v-7e2b81b6]{font-size:6rem;font-weight:700}@media (min-width:1024px){.title[data-v-7e2b81b6]{font-size:8rem}}.title[data-v-7e2b81b6]{line-height:6rem}@media (min-width:1024px){.title[data-v-7e2b81b6]{line-height:7rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
